<template>
  <qx-card-form title="车辆保养" v-show="showComponent" :defaultContentShow="false">
    <span slot="titleLeft" class="notices error"  style="margin-left: 10px" v-if="isNextMaintainTimeShow || isAccumulatedMileageShow">
      注意：<span v-if="isNextMaintainTimeShow"> 【下次保养日期】</span>
      <span v-if="isAccumulatedMileageShow">【下次保养里程数】</span>
     ，需在车辆保养内维护</span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="160px">
      <span slot="maintainWaringDayTip" class="tip">距到期日提前预警的天数设置</span>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {dealNumber} from '@qx/utils';

export default {
  data () {
    return {
      showComponent: true,
      isNextMaintainTimeShow: false, // 是否显示【下次保养日期】数据维护提示
      isAccumulatedMileageShow: false, // 是否显示【下次保养里程数】数据维护提示
      baseForm: {
        maintainMethodOptions: [],
        form: [
          {
            label: '保养方式',
            value: 'maintainMethod',
            type: 'radio',
            default: '1',
            onChange: (maintainMethod) => {
              this.setFormAttrVal({
                form: this.baseForm,
                attr: 'hide',
                value: maintainMethod === '1',
                names: ['accumulatedMileage', 'mileageDriven'],
              });
              this.setFormAttrVal({
                form: this.baseForm,
                attr: 'hide',
                value: maintainMethod === '2',
                names: ['nextMaintainTime', 'maintainWaringDay'],
              });
              console.log('111', this.$refs.baseForm.getVal('nextMaintainTime'));
              this.setFormAttrVal({
                form: this.baseForm,
                attr: 'disabled',
                value: Boolean(this.$refs.baseForm.getVal('nextMaintainTime')),
                names: ['nextMaintainTime'],
              });
              this.setFormAttrVal({
                form: this.baseForm,
                attr: 'disabled',
                value: Boolean(this.$refs.baseForm.getVal('accumulatedMileage')),
                names: ['accumulatedMileage'],
              });
            },
          },
          {
            label: '下次保养日期',
            value: 'nextMaintainTime',
            type: 'date',
            placeholder: '请选择下次保养日期',
            attr: {
              time: '00:00:00',
            },
            hide: true,
          },
          {
            label: '到期预警天数',
            value: 'maintainWaringDay',
            type: 'input',
            placeholder: '请输入到期预警天数',
            default: 60,
            hide: true,
            onInput: (maintainWaringDay) => {
              this.$refs.baseForm.setVal('maintainWaringDay', maintainWaringDay.replace(/^(0+)|[^\d]+/g, ''));
            },
          },
          {
            label: '下次保养里程数（km）',
            value: 'accumulatedMileage',
            type: 'input',
            placeholder: '请输入下次保养里程数，用于保养提醒',
            width: '260px',
            hide: true,
            onInput: (accumulatedMileage) => {
              this.$refs.baseForm.setVal('accumulatedMileage', dealNumber(accumulatedMileage, false));
            },
          },
          {
            label: '已行驶里程（km）',
            value: 'mileageDriven',
            type: 'input',
            placeholder: '请输入现有里程数',
            width: '260px',
            hide: true,
            default: '0',
            onInput: (mileageDriven) => {
              this.$refs.baseForm.setVal('mileageDriven', dealNumber(mileageDriven, false));
            },
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    async setList (options) {
      this.baseForm.maintainMethodOptions = options.maintainMethodOptions;
    },

    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ext: {
            maintainMethod: formData.maintainMethod,
            nextMaintainTime: formData.nextMaintainTime,
            maintainWaringDay: formData.maintainWaringDay,
            accumulatedMileage: formData.accumulatedMileage,
            mileageDriven: formData.mileageDriven,
          },
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      formData = {
        ...formData,
        'ext.maintainMethod': formData.maintainMethod,
        'ext.nextMaintainTime': this.formatDate(formData.nextMaintainTime),
        'ext.maintainWaringDay': formData.maintainWaringDay,
        'ext.accumulatedMileage': formData.accumulatedMileage,
        'ext.mileageDriven': formData.mileageDriven,
      };
      delete formData.ext;
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 重置表单为初始状态
      this.resetBaseForm(data.vehicleClass);
      if (!data.maintainMethod) {
        data.maintainMethod = '1';
      }
      if (data.ext) {
        if (data.ext.maintainMethod !== undefined) {
          data.maintainMethod = String(data.ext.maintainMethod);
        }
        if (data.ext.nextMaintainTime !== undefined) {

          data.nextMaintainTime = data.ext.nextMaintainTime;
          if (data.maintainMethod === '1') {
            this.isNextMaintainTimeShow = true;
            this.setFormAttrVal({
              form: this.baseForm,
              attr: 'disabled',
              value: true,
              names: ['nextMaintainTime'],
            });
          }
        } else {
          this.isNextMaintainTimeShow = false;
        }
        if (data.ext.maintainWaringDay) {
          data.maintainWaringDay = data.ext.maintainWaringDay;
        }
        if (data.ext.accumulatedMileage !== undefined) {
          data.accumulatedMileage = data.ext.accumulatedMileage;
          if (data.maintainMethod === '2') {
            this.isAccumulatedMileageShow = true;
            this.setFormAttrVal({
              form: this.baseForm,
              attr: 'disabled',
              value: true,
              names: ['accumulatedMileage'],
            });
          }
        } else {
          this.isAccumulatedMileageShow = false;
        }
        if (data.ext.mileageDriven) {
          data.mileageDriven = data.ext.mileageDriven;
        }
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: data.ext.maintainMethod === 2,
          names: ['nextMaintainTime', 'maintainWaringDay'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: data.ext.maintainMethod === 1,
          names: ['accumulatedMileage', 'mileageDriven'],
        });
      }
      if (!data.mileageDriven) {
        data.mileageDriven = '0';
      }
      if (!data.maintainWaringDay) {
        data.maintainWaringDay = 60;
      }
      this.$refs.baseForm.setVal(data);
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.showComponent = false;
      // 切换成临时外调车
      this.setBaseForm('outward');
    },
    resetToNormal (vehicleClass) {
      this.vehicleClass = vehicleClass;
      if (vehicleClass === '1') {
        this.showComponent = true;
      } else {
        this.showComponent = false;
      }
      this.setBaseForm('my');

    },
    resetBaseForm (vehicleClass) {
      if (this.$route.query.type === 'my') {
        this.setBaseForm('my');
        if (vehicleClass === '1' || this.vehicleClass === '1') {
          this.showComponent = true;
        } else {
          this.showComponent = false;
        }
      } else {
        this.setBaseForm('outward');
        this.showComponent = false;
      }
    },
    setBaseForm (mode) {
      if (mode === 'my') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['maintainMethod', 'nextMaintainTime', 'maintainWaringDay'],
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
        });
      }
    },
    async formChange (vehicleInfo) {
      this.resetBaseForm();
      let parametersFormNames = ['nextMaintainTime', 'maintainWaringDay'];
      if (vehicleInfo) {
        // 隐藏不用填写的项
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: parametersFormNames,
        });
      }
      if (this.$route.query.type === 'my') {
        if (vehicleInfo) {
          if (!this.$route.query.id) {
            this.showComponent = false;
          }
        } else {
          this.showComponent = true;
        }
      }
    },
    receivedData (vehicleInfo) {
      this.formChange(vehicleInfo);
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-left: 20px;
  color:#AAAAAA;
}
</style>
